module.exports = __webpack_public_path__ + "img/weal_content_5.5fe0589d.png";